import axios from './interceptor'
import { baseUrl } from './config'
import * as _ from 'lodash'

export default {
  async getWaiterVersion () {
    const res = await axios.get(`${baseUrl}/s/health/version`, {
      params: {
        client: 'waiter',
      },
    })
    return _.get(res, 'data.version')
  },
}



// WEBPACK FOOTER //
// ./src/services/api/health.js